export default function isAbsolutePositioning(element: HTMLElement) {
    const { position } = window.getComputedStyle(element)
    return position === 'absolute'
}
